<template>
  <button v-show="showBackTop" id="backtop" type="button" aria-label="Back to top" @click="scrollToTop">
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-top">
      <path d="M12 19V6.5" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" vector-effect="non-scaling-stroke" />
      <path d="M6.8 11.4 12 6.2l5.2 5.2" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke" />
    </svg>
  </button>
</template>

<script>
export default {
    data() {
    return {
      showBackTop: false,
    };
  },
  mounted() {
    if (window) {
      window.onscroll = function () {
        let currentHeight =
          document.documentElement.scrollTop ||
          window.pageYOffset ||
          document.body.scrollTop;
        if (currentHeight > 300) {
          this.showBackTop = true;
          document.getElementById("backtop").style.display = "block";
        } else {
          this.showBackTop = false;
          document.getElementById("backtop").style.display = "none";
        }
      };
    }
  },
  methods: {
    scrollToTop() {
      let topHeight =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      let speed = topHeight / 10 > 100 ? topHeight / 10 : 100;
      scrollBy(0, -speed);
      // 模拟鼠标向上滚动事件
      this.scrolldelay = setTimeout(this.scrollToTop, 50);
      // 清除滚动事件，避免无法向下移动
      if (topHeight === 0) {
        clearTimeout(this.scrolldelay);
        this.scrolldelay = null;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#backtop {
	display: grid;
	place-items: center;
	width: 54px;
	height: 54px;
	position: fixed;
	right: 24px;
	bottom: 100px;
	padding: 0;
	border: 1px solid rgba(255, 255, 255, 0.18);
	border-radius: 50%;
	background: linear-gradient(145deg, #32f079 0%, #12bf4f 58%, #07933a 100%);
	box-shadow: 0 14px 30px rgba(18, 191, 79, 0.34), inset 0 1px 0 rgba(255, 255, 255, 0.28);
	box-sizing: border-box;
	color: #fff;
	cursor: pointer;
	z-index: 1001;
	transition: transform 0.18s ease, box-shadow 0.18s ease;

	svg {
		display: block;
		width: 28px;
		height: 28px;
	}

	&:hover {
		box-shadow: 0 18px 38px rgba(18, 191, 79, 0.42), inset 0 1px 0 rgba(255, 255, 255, 0.32);
		transform: translateY(-2px);
	}
}
</style>
